import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../layout/Layout';
import ServiceLayout from '../components/ServiceLayout';

export default function SoftwareTraining() {
  return (
    <Layout>
      <ServiceLayout
        title="Software Training"
        banner="/assets/images/banner/software_training.jpg"
        current="/software-training"
      >
        <div className="space-y-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-brand-dark mb-4">Software Training</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              Our Fullstack Software Training and Mobile App Development course offer comprehensive coverage of the MERN (MongoDB, Express.js, React.js, Node.js) stack alongside mobile app development frameworks like React Native.
            </p>
            <p className="text-gray-600 leading-relaxed mb-3">
              From building robust backend systems to crafting captivating user interfaces, we provide a holistic learning experience that prepares you for real-world challenges.
            </p>
            <h3 className="text-lg font-bold font-heading text-brand-dark mb-2">Experienced Instructors</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Learn from industry experts who are passionate about sharing their knowledge and insights. Our instructors bring years of experience in Fullstack Development and Mobile App Development, ensuring that you receive top-notch guidance throughout your learning journey.
            </p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 list-none p-0">
              {['Expert Insight', 'Professional Growth'].map((item) => (
                <li key={item} className="flex items-center gap-3 text-brand-dark/80 text-sm">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand/10 flex items-center justify-center">
                    <span className="icon-check-circle text-brand text-xs"></span>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <img src="softwaretraining.jpg" alt="#" className="w-full rounded-2xl shadow-md" />

          <div>
            <p className="text-gray-600 leading-relaxed mb-6">
              Software training is an invaluable tool for anyone who wants to excel in the digital age. By investing in your skills, you can unlock new opportunities, increase your earning potential, and stay ahead of the curve.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                { icon: 'icon-web-design', title: 'Flexibility', desc: 'Our course provides flexible learning options tailored to your busy life — from self-paced to live instructor-led sessions. Learn on your terms, at your own pace.' },
                { icon: 'icon-data', title: 'Career Support', desc: 'We prioritize your success by offering technical training and career support, including resume building and interview preparation, ensuring a smooth transition into software development.' },
              ].map(({ icon, title, desc }) => (
                <div key={title} className="flex items-start gap-4 bg-gray-50 rounded-xl p-5 border border-gray-100">
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-brand flex items-center justify-center">
                    <span className={`${icon} text-white text-xl`}></span>
                  </div>
                  <div>
                    <h3 className="text-brand-dark font-bold font-heading mb-2">{title}</h3>
                    <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="flex-1">
              <p className="text-gray-600 leading-relaxed">
                Theory is important, but practical experience is essential. That's why our course emphasizes hands-on learning through projects that simulate real-world scenarios. Build a diverse portfolio of applications and showcase your skills to potential employers.
              </p>
            </div>
            <div className="flex-shrink-0 md:w-48">
              <img src="/assets/images/services/img2.png" alt="#" className="w-full rounded-xl shadow-sm" />
            </div>
          </div>
        </div>
      </ServiceLayout>
    </Layout>
  );
}
